import * as action from '../store/action-types'

function templateOptionProp (key, options) {
  options = Object.assign({}, options)
  return {
    get: function () {
      const value = this.$store.getters.templateOptions(this.templateId)[key] || options.default
      return (value === null || value === undefined) ? options.default : value
    },
    set: function (val) {
      this.$store.dispatch(action.TEMPLATE_OPTIONS, {
        templateId: this.templateId,
        options: {[key]: val}
      })
    }
  }
}

export default templateOptionProp



// WEBPACK FOOTER //
// ./src/utils/templateOptionProp.js